import { RcFile } from 'antd/es/upload';
import jwtDecode from 'jwt-decode';

export const isEmptyObject = (obj: object) => JSON.stringify(obj) === '{}';

export const imagePlaceholder =
  'https://www.unfe.org/wp-content/uploads/2019/04/SM-placeholder.png';

export function swapElements(arr: any[], i1: number, i2: number) {
  [arr[i1], arr[i2]] = [arr[i2], arr[i1]];
}

export function slugify(string: string, separator = '-') {
  return string
    .toString() // Cast to string (optional)
    .toLowerCase() // Convert the string to lowercase letters
    .trim() // Remove whitespace from both sides of a string (optional)
    .replace(/\s+/g, separator) // Replace spaces with -
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\_/g, separator) // Replace _ with -
    .replace(/\-\-+/g, separator) // Replace multiple - with single -
    .replace(/\-$/g, ''); // Remove trailing -
}

export const getRandomAdjective = () => {
  const randomIndex = Math.floor(Math.random() * adjectives.length);
  return adjectives[randomIndex];
};

const formatter = new Intl.RelativeTimeFormat(undefined, {
  numeric: 'auto',
});

export const formatTimeAgo = (date: any) => {
  let duration = (new Date(date) - new Date()) / 1000;

  for (let i = 0; i < DIVISIONS.length; i++) {
    const division = DIVISIONS[i];
    if (Math.abs(duration) < division.amount) {
      return formatter.format(Math.round(duration), division.name);
    }
    duration /= division.amount;
  }
  return duration;
};

export const toBase64 = (file: RcFile) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

export const renameFile = (file: File, newName: string): File => {
  return new File([file], newName, {
    type: file.type,
    lastModified: file.lastModified,
  });
};

const DIVISIONS = [
  { amount: 60, name: 'seconds' },
  { amount: 60, name: 'minutes' },
  { amount: 24, name: 'hours' },
  { amount: 7, name: 'days' },
  { amount: 4.34524, name: 'weeks' },
  { amount: 12, name: 'months' },
  { amount: Number.POSITIVE_INFINITY, name: 'years' },
];

export const isScrollable = (element: any) => {
  // Compare the height to see if the element has scrollable content
  const hasScrollableContent = element.scrollHeight > element.clientHeight;

  // It's not enough because the element's `overflow-y` style can be set as
  // * `hidden`
  // * `hidden !important`
  // In those cases, the scrollbar isn't shown
  const overflowYStyle = window.getComputedStyle(element).overflowY;
  const isOverflowHidden = overflowYStyle.indexOf('hidden') !== -1;

  return hasScrollableContent && !isOverflowHidden;
};

export const didTokenExpire = (token: string) => {
  try {
    if (!token) return false;
    return jwtDecode(token)?.exp < Math.floor(Date.now() / 1000);
  } catch (error) {
    return false;
  }
};

export const emailPattern =
  /(^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$)/;

export const intialsFromName = (name?: string) => {
  if (!name) {
    return '';
  }

  const words = name.split(' ');
  if (words.length === 1) {
    return words[0].substring(0, 2);
  } else {
    return words[0][0] + words[1][0];
  }
};

const adjectives = [
  'adorable',
  'amazing',
  'amiable',
  'appealing',
  'artistic',
  'attractive',
  'awesome',
  'beautiful',
  'blissful',
  'bold',
  'brave',
  'bright',
  'brilliant',
  'calm',
  'capable',
  'captivating',
  'caring',
  'charming',
  'cheerful',
  'chic',
  'charming',
  'classy',
  'colorful',
  'comfortable',
  'compassionate',
  'confident',
  'considerate',
  'cool',
  'courageous',
  'creative',
  'cute',
  'daring',
  'dazzling',
  'delicate',
  'delightful',
  'elegant',
  'empathetic',
  'enchanting',
  'encouraging',
  'energetic',
  'engaging',
  'enlightened',
  'enthusiastic',
  'exquisite',
  'extraordinary',
  'fabulous',
  'fantastic',
  'fascinating',
  'flawless',
  'friendly',
  'fun',
  'generous',
  'gentle',
  'genuine',
  'glamorous',
  'glorious',
  'gorgeous',
  'graceful',
  'gracious',
  'happy',
  'harmonious',
  'heartwarming',
  'heavenly',
  'helpful',
  'heroic',
  'high-spirited',
  'honest',
  'hopeful',
  'humorous',
  'idealistic',
  'imaginative',
  'impressive',
  'incredible',
  'ingenious',
  'innovative',
  'insightful',
  'inspiring',
  'intelligent',
  'interesting',
  'invigorating',
  'joyful',
  'jubilant',
  'kind',
  'lively',
  'loving',
  'lovely',
  'luminous',
  'luxurious',
  'magnificent',
  'marvelous',
  'mesmerizing',
  'miraculous',
  'noble',
  'optimistic',
  'outstanding',
  'passionate',
  'peaceful',
  'perfect',
  'playful',
  'pleasing',
  'positive',
  'powerful',
  'radiant',
  'refreshing',
  'remarkable',
  'resilient',
  'romantic',
  'sensational',
  'serene',
  'sparkling',
  'splendid',
  'stunning',
  'sublime',
  'successful',
  'sunny',
  'superb',
  'supportive',
  'surprising',
  'sweet',
  'talented',
  'tasteful',
  'terrific',
  'thrilling',
  'tremendous',
  'trusting',
  'truthful',
  'unbelievable',
  'unique',
  'unforgettable',
  'uplifting',
  'valiant',
  'vibrant',
  'victorious',
  'vivacious',
  'warm',
  'whimsical',
  'witty',
  'wonderful',
  'wondrous',
  'zealous',
];
